export enum AccessLevels {
  Collector = 1,
  Census = 2,
  StoreManager = 3,
  ZoneManager = 4,
  RegionManager = 5,
  Coordinator = 6,
  CommercialManager = 7,
  HelpDesk = 8,
  Admin = 9,
  FinanceManager = 5,
}


export function castAccessLevel(role: string): AccessLevels {
  return AccessLevels[role as keyof typeof AccessLevels];
}